import { colors, space } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const DrawerDivider = styled.hr`
  margin: 0 -${space.large};
  overflow: auto;
  border-top: 1px solid ${colors.borderSubtle};
`;
